module.exports = __webpack_public_path__ + "74a35f1aac8a38ad9adf0ebcf29477f3.svg";